import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    graficoPossuiValor,
} from '../estudo-form/EstudoServiceCalculo'

import DespesasAcumuladasChart from '../estudo-chart/DespesasAcumuladasChart'



const EstudoReportDespesasAcumuladas = ({ values, handleChange, estudo }) => {

    const exibirSemDiaDia = graficoPossuiValor(estudo.current.graficoEducacao) || 
        graficoPossuiValor(estudo.current.graficoProjetoVidaSonho) || 
            graficoPossuiValor(estudo.current.graficoFinanciamento) ||
                graficoPossuiValor(estudo.current.graficoDiaDiaDespesasTemporarias)

    return (
        <div
            className={(relatorioModoApresentacao(values) ? 'mt-10' : '')} // mudança da fonte
        >
            {!values.naoExibirDespesasAcumuladasSemDiaDia && exibirSemDiaDia&& (
                <DespesasAcumuladasChart
                    values={values}
                    handleChange={handleChange}
                    estudo={estudo}
                    comSemDiaDiaEstudo={HARDCODE.comSemDiaDiaEstudoSem}
                    report={true}
                />
            )}

            <DespesasAcumuladasChart 
                values={values}
                handleChange={handleChange}
                estudo={estudo}
                comSemDiaDiaEstudo={HARDCODE.comSemDiaDiaEstudoCom}
                naoExibirDespesasAcumuladasSemDiaDia={!exibirSemDiaDia}
                report={true}
            />
        </div>
    )
}

export default EstudoReportDespesasAcumuladas